import type { TenantStatus } from "~/helpers/modules/rent-roll-helpers";

export const useTenantStatusOptions = () => {
  const t = useTranslator();
  const filter = useFilter();

  return computed<{ [k in TenantStatus]: { id: k; name: string; color: "yellow" | "red" | "green" } }>(() => ({
    noUpcomingTenant: { id: "noUpcomingTenant", name: filter.capitalize(t("PORTFOLIO_VIEW_TENANCIES_NO_UPCOMING_TENANT")), color: "yellow" },
    upcomingTenant: { id: "upcomingTenant", name: filter.capitalize(t("PORTFOLIO_VIEW_TENANCIES_UPCOMING_TENANT")), color: "green" },
  }));
};
